export default {
  a: "a",
  button: "button"
};
